import { useTranslation } from 'react-i18next';
import s from './styles';

function CompanyName({ companyName }) {
  const { t } = useTranslation();
  return (
    <s.Container>
      <s.TextContainer>
        {!companyName ? (
          t('containers.Dashboard.CompanyName.welcome')
        ) : (
          <>
            {t('containers.Dashboard.CompanyName.welcome')},{' '}
            <i> {companyName}</i>
          </>
        )}
      </s.TextContainer>
    </s.Container>
  );
}

export default CompanyName;
